var _defs, _rect, _rect2, _g, _text, _text2, _text3, _text4, _text5, _g2, _g3, _g4, _g5, _line, _rect3, _text6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapacityPlanningAiAgents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 630",
    width: 1200,
    height: 630,
    role: "img",
    "aria-label": "Capacity planning when part of your team is software: a demand line above fixed human capacity bars, with an elastic metered agent capacity band closing the gap",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cbg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#171523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cglow",
    cx: 0.68,
    cy: 0.42,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7a4e6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7a4e6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cai",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f7fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b7a4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fd8f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cgold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f6cf6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chum",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a4f93"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "csoft",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("style", null, "\n      .h  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 800; fill: #f4f0fc; }\n      .s  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 600; fill: #b8b2cc; }\n      .eyebrow { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #cfc3ee; letter-spacing: 4px; }\n      .lab { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #121020; }\n      .axis { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #cfc3ee; }\n      .tick { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 600; fill: #8e86a8; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#cbg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#cglow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2a2547",
    strokeWidth: 1,
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90 H1200 M0 180 H1200 M0 270 H1200 M0 360 H1200 M0 450 H1200 M0 540 H1200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0 V630 M300 0 V630 M450 0 V630 M600 0 V630 M750 0 V630 M900 0 V630 M1050 0 V630"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 116,
    className: "eyebrow",
    fontSize: 19
  }, "CAPACITY PLANNING")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 186,
    className: "h",
    fontSize: 56
  }, "Seats are fixed.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 250,
    className: "h",
    fontSize: 56
  }, "Agents are not.")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 298,
    className: "s",
    fontSize: 23
  }, "Plan the work, not the headcount.")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 588,
    className: "s",
    fontSize: 20,
    opacity: 0.8
  }, "BOSSDROP.AI")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 520,
    x2: 1140,
    y2: 520,
    stroke: "#4c4380",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 1140,
    y: 166,
    textAnchor: "end",
    className: "axis",
    fontSize: 18,
    fill: "#f6cf6a"
  }, "demand for the quarter"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 170,
    width: 96,
    height: 350,
    rx: 8,
    fill: "#241f3d",
    stroke: "#4c4380",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 552,
    textAnchor: "middle",
    className: "tick",
    fontSize: 16
  }, "planned"), /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 572,
    textAnchor: "middle",
    className: "tick",
    fontSize: 16
  }, "headcount"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 352,
    width: 96,
    height: 168,
    rx: 8,
    fill: "url(#chum)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 792,
    y: 552,
    textAnchor: "middle",
    className: "tick",
    fontSize: 16
  }, "usable"), /*#__PURE__*/React.createElement("text", {
    x: 792,
    y: 572,
    textAnchor: "middle",
    className: "tick",
    fontSize: 16
  }, "human hours"), /*#__PURE__*/React.createElement("g", {
    stroke: "#f6a35a",
    strokeWidth: 2.5,
    fill: "none",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M856 186 H874 M856 352 H874 M865 186 V352"
  })), /*#__PURE__*/React.createElement("text", {
    x: 886,
    y: 252,
    className: "axis",
    fontSize: 17,
    fill: "#f6a35a"
  }, "the gap"), /*#__PURE__*/React.createElement("text", {
    x: 886,
    y: 276,
    className: "tick",
    fontSize: 14
  }, "meetings,"), /*#__PURE__*/React.createElement("text", {
    x: 886,
    y: 295,
    className: "tick",
    fontSize: 14
  }, "incidents,"), /*#__PURE__*/React.createElement("text", {
    x: 886,
    y: 314,
    className: "tick",
    fontSize: 14
  }, "unplanned work"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1012,
    y: 352,
    width: 96,
    height: 168,
    rx: 8,
    fill: "url(#chum)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1012,
    y: 186,
    width: 96,
    height: 172,
    rx: 8,
    fill: "url(#cai)",
    filter: "url(#csoft)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1012,
    y: 186,
    width: 96,
    height: 172,
    rx: 8,
    fill: "url(#cai)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1060,
    y: 282,
    textAnchor: "middle",
    className: "lab",
    fontSize: 17
  }, "agent"), /*#__PURE__*/React.createElement("text", {
    x: 1060,
    y: 302,
    textAnchor: "middle",
    className: "lab",
    fontSize: 17
  }, "capacity"), /*#__PURE__*/React.createElement("text", {
    x: 1060,
    y: 552,
    textAnchor: "middle",
    className: "tick",
    fontSize: 16
  }, "blended"), /*#__PURE__*/React.createElement("text", {
    x: 1060,
    y: 572,
    textAnchor: "middle",
    className: "tick",
    fontSize: 16
  }, "plan"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 186,
    x2: 1140,
    y2: 186,
    stroke: "#f6cf6a",
    strokeWidth: 3.5,
    strokeDasharray: "11 7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 592,
    width: 580,
    height: 2,
    fill: "#2a2547"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 616,
    className: "tick",
    fontSize: 15
  }, "Humans are bought in seats. Agents are metered in runs and approvals.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacityPlanningAiAgents);
export default __webpack_public_path__ + "static/media/capacity-planning-ai-agents.f6b6d27620d05a8d8ffd271e2ae435b4.svg";
export { ForwardRef as ReactComponent };